import { render, staticRenderFns } from "./TheAdminUserTab.vue?vue&type=template&id=639e721a&scoped=true"
import script from "./TheAdminUserTab.vue?vue&type=script&lang=js"
export * from "./TheAdminUserTab.vue?vue&type=script&lang=js"
import style0 from "./TheAdminUserTab.vue?vue&type=style&index=0&id=639e721a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639e721a",
  null
  
)

export default component.exports